export const ACCESS_EXPIRED = 'Access expired.'
export const USE_ONLY_ONCE = 'This URL can be used only once'
export const EMAIL_VERIFIED = 'Your email was verified. You can continue using the application.'
